module.exports = "https://payments.pagoefectivo-pre.com/error-desktop-full.dcaca977e0f3734a01c9cd969e7db9d5.png";